import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { useParams, useRouteMatch } from "react-router-dom";
import DateTimePicker from "react-datetime-picker";

const CREATE_SHOW_MUTATION = gql`
  mutation createShowMutation(
    $name: String!
    $description: String!
    $start_time: Time!
    $end_time: Time!
    $thumbnail: String!
    $venue: ShowVenueRelation!
  ) {
    createShow(
      data: {
        name: $name
        description: $description
        start_time: $start_time
        end_time: $end_time
        thumbnail: $thumbnail
        venue: $venue
      }
    ) {
      _id
      name
      description
      start_time
      end_time
      thumbnail
      venue {
        name
      }
    }
  }
`;

export default function EventForm() {
  // const [placeValue, setPlaceValue] = useState(null);
  // const [formValidated, setFormValidated] = useState(false);
  // const history = useHistory();
  const { portalVenue } = useParams();
  let { path } = useRouteMatch();
  const [image, setImage] = useState("");
  const [imgUrl, setImgUrl] = useState("");

  const [startTimeValue, onStartTimeChange] = useState(new Date());
  const [endTimeValue, onEndTimeChange] = useState(new Date());

  const [images, setImages] = React.useState([]);
  const maxNumber = 1;

  const onImageChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  const uploadImage = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("file", image);
    data.append("upload_preset", "a7xscswa");
    data.append("cloud_name", "computer-computer");

    fetch("  https://api.cloudinary.com/v1_1/computer-computer/image/upload", {
      method: "post",
      body: data,
    })
      .then((resp) => resp.json())
      .then((data) => {
        setImgUrl(data.secure_url);
        setShowFormState({
          ...showFormState,
          thumbnail: imgUrl,
        });
      })
      .catch((err) => console.log(err));
  };

  const [showFormState, setShowFormState] = useState({
    name: "",
    description: "",
    startTime: startTimeValue,
    endTime: endTimeValue,
    thumbnail: imgUrl,
    venue: portalVenue,
  });

  const [submissionSuccess, setsubmissionSuccess] = useState(false);

  const handleShowFormSubmission = () => {
    setsubmissionSuccess(true);
    setShowFormState({
      name: "",
      description: "",
      startTime: "",
      endTime: "",
      thumbnail: "",
      venue: "",
    });
  };

  const [createShow, { showLoading, showError }] = useMutation(
    CREATE_SHOW_MUTATION,
    {
      variables: {
        name: showFormState.name,
        description: showFormState.description,
        start_time: showFormState.startTime,
        end_time: showFormState.endTime,
        thumbnail: showFormState.thumbnail,
        venue: { connect: showFormState.venue },
      },
      onCompleted: () => handleShowFormSubmission(),
    }
  );

  const FormStatus = () => {
    if (showLoading)
      return (
        <div>
          <p>loading zone</p>
        </div>
      );
    if (showError) return `Submission error! ${showError.message}`;
    if (submissionSuccess)
      return (
        <div>
          <p>Success!</p>
        </div>
      );
    return <p></p>;
  };

  return (
    <div className="lg:grid lg:grid-cols-12 lg:gap-x-5 pt-12 h-screen overflow-y-auto">
      <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">
        <form
          action="#"
          className=""
          onSubmit={(e) => {
            e.preventDefault();
            createShow();
          }}
        >
          <div className="shadow sm:rounded-md sm:overflow-hidden">
            <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
              <div>
                <p className="mt-1 text-sm text-gray-500">
                  This information will be displayed publicly as the event
                  listing.
                </p>
              </div>

              <div className="grid grid-cols-3 gap-6">
                <div className="col-span-3 sm:col-span-2 space-y-6">
                  <div>
                    <div className="mt-1 rounded-md shadow-sm flex">
                      <span className="bg-gray-50 border border-r-0 border-gray-300 rounded-l-md px-3 inline-flex items-center text-gray-500 sm:text-sm">
                        title
                      </span>
                      <input
                        type="text"
                        name="event"
                        id="event"
                        autoComplete="event"
                        className="focus:ring-indigo-500 focus:border-indigo-500 flex-grow block w-full min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300"
                        value={showFormState.name}
                        onChange={(e) =>
                          setShowFormState({
                            ...showFormState,
                            name: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div>
                    <span className=" text-gray-500 sm:text-sm">
                      description
                    </span>
                    <div className="mt-1 rounded-md shadow-sm">
                      <textarea
                        name="event"
                        id="event description"
                        autoComplete="event description"
                        className="focus:ring-indigo-500 focus:border-indigo-500 flex-grow block w-full min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300"
                        value={showFormState.description}
                        onChange={(e) =>
                          setShowFormState({
                            ...showFormState,
                            description: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div>
                    <label
                      htmlFor="start time"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      event starting date & time
                    </label>
                    <DateTimePicker
                      onChange={onStartTimeChange}
                      value={startTimeValue}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="start time"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      event ending date & time
                    </label>
                    <DateTimePicker
                      onChange={onEndTimeChange}
                      value={endTimeValue}
                    />
                  </div>
                  <div className="col-span-3">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="px-4">
              {imgUrl ? (
                <></>
              ) : (
                <h1 className="py-4">Select an image for your event.</h1>
              )}

              <img className={`${imgUrl ? "py-4" : ""}`} src={imgUrl} />
              <input
                type="file"
                onChange={(e) => setImage(e.target.files[0])}
              ></input>
              <button onClick={uploadImage}>Upload</button>
            </div>
            <div className="px-4 py-4 bg-gray-50 flex justify-between sm:px-6">
              <FormStatus />
              <button
                type="submit"
                className="bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
